module.exports = __webpack_public_path__ + "img/mc.543bc93b.svg";